<ng-container *ngIf="viewModel$ | async as vm">
  <ng-container *ngIf="vm.display">
    <ng-container [ngSwitch]="vm.module.type">
      <ng-container *ngSwitchCase="'NAMain'" [ngTemplateOutlet]="Weather"></ng-container>
      <ng-container *ngSwitchCase="'NAModule1'" [ngTemplateOutlet]="Weather"></ng-container>
      <ng-container *ngSwitchCase="'NAModule4'" [ngTemplateOutlet]="Weather"></ng-container>
      <ng-container *ngSwitchCase="'NATherm1'" [ngTemplateOutlet]="Energy"></ng-container>
      <ng-container *ngSwitchCase="'NRV'" [ngTemplateOutlet]="Energy"></ng-container>
    </ng-container>

    <ng-template #Weather>
      <app-dataset-card (click)="selectModule(vm.module)"
        [selected]="sidebarRoomService.isSelected(vm.card, vm.module, GraphType.TEMPERATURE)"
        [backgroundColor]="'var(--blue-10)'"
        [hoverBackgroundColor]="'var(--blue-5)'">
        <app-dataset-card-label>{{ 'common-app.__TEMPERATURE' | LANG }}</app-dataset-card-label>
        <app-dataset-card-value class="text-blue">{{ vm.unreachable ? '--' : getTemperatureDisplay(vm.module, vm.room) | toUserUnit : EnumMeasureTypes.TEMPERATURE | toDisplayValue : EnumMeasureTypes.TEMPERATURE }}</app-dataset-card-value>
        <app-dataset-card-unit>
          <app-text unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>
        </app-dataset-card-unit>
        <app-dataset-card-preview [module]="vm.module" [measureType]="EnumMeasureTypes.TEMPERATURE"></app-dataset-card-preview>
      </app-dataset-card>
    </ng-template>

    <ng-template #Energy>
      <app-set-point-card [module]="vm.module" [room]="vm.room"></app-set-point-card>

      <app-dataset-card (click)="selectModule(vm.module)"
        [selected]="sidebarRoomService.isSelected(vm.card, vm.module, GraphType.THERM)"
        [backgroundColor]="'var(--blue-10)'"
        [hoverBackgroundColor]="'var(--blue-5)'">

        <app-dataset-card-label>{{ 'common-app.__TEMPERATURE' | LANG }}</app-dataset-card-label>
        <app-dataset-card-value class="text-blue">{{ vm.unreachable ? '--' : getTemperatureDisplay(vm.module, vm.room) | toUserUnit : EnumMeasureTypes.TEMPERATURE | toDisplayValue : EnumMeasureTypes.TEMPERATURE }}</app-dataset-card-value>
        <app-dataset-card-unit>
          <app-text unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>
        </app-dataset-card-unit>
        <app-dataset-card-preview [module]="vm.module" [measureType]="EnumMeasureTypes.TEMPERATURE"></app-dataset-card-preview>
      </app-dataset-card>

    </ng-template>
  </ng-container>

</ng-container>
